module.exports = __webpack_public_path__ + "static/rfa-home@2x-1838f928f8a8b290bd306c3c72384d1a.png";